import { newToolFilterOAuthMcp } from "../oauth.ts";

export const wixMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://www.wix.com/favicon.ico",
  url: "https://mcp.wix.com/mcp",
  label: "Wix",
});
